import ConfirmSheet from './Confirm-sheet.vue'

export default {
	install (Vue, options) {
		const Confirm = Vue.extend(ConfirmSheet)
		let instance = null
		let getToastInstance = () => {
			if (instance) {
				return instance
			}
			return new Confirm({
				el: document.createElement('div')
			})
		}
		let $Confirm = (options = {}) => {
			return new Promise((resolve, reject) => {
				instance = getToastInstance()
				instance.message = typeof options === 'string' ? options : options.message
				instance.btns = options.btns || ['确定', '取消']
				instance.type = options.type
				instance.confirmHandler = resolve
				instance.cancelHandler = reject
				document.body.appendChild(instance.$el)
				Vue.nextTick(function () {
					instance.visible = true
					instance.actionShow = true
				})
				return instance
			})
		}
		$Confirm.getVisiable = function () {
			return instance && instance.actionShow
		}
		$Confirm.close = function () {
			instance && instance.hide()
		}
		let $alert = function (msg) {
			let params = {
				type: 'alert'
			}
			if (typeof msg === 'string') {
				params.message = msg
			} else if (Object.prototype.toString.call(msg) === '[object Object]') {
				params = Object.assign(params, msg)
				params.type = 'alert'
			}
			return $Confirm(params)
		}
		Vue.prototype.$fxConfirmSheet = $Confirm
		Vue.prototype.$fxAlertSheet = $alert
	}
}



// WEBPACK FOOTER //
// ./src/lib/wind-ui/package/confirmSheet/index.js